export default __webpack_public_path__ + "static/media/pic4.86fbf10e.jpg";